import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { RootState } from "src/redux/store";
import config from "#config";
import { membershipGrants, storePermissionsFor } from "#permissions/adapter";

export const getUser = (state: RootState) => state.user;

export const getUserAdminPermission = createSelector(
    [getUser],
    (user) => user?.snackpassPermissions?.isAdmin ?? false,
);

export const getUserFinancialReportsPermission = (storeId?: string) =>
    createSelector(
        [getUser],
        (user) =>
            (user?.snackpassPermissions.isSnackpassEmployee ||
                membershipGrants(user, storeId, "reports:financial")) ??
            false,
    );

/** The 27-flag view route gating consumes, generated from memberships (ENG-11161). */
export const getStorePermissions = createSelector([getUser], (user) =>
    storePermissionsFor(user),
);

export const getUserTeamPermission = createSelector(
    [getUser],
    (user) => user?.snackpassPermissions?.isSnackpassEmployee ?? false,
);

export const getUserIsSnackpassEmployee = createSelector(
    [getUser],
    (user) => user?.snackpassPermissions?.isSnackpassEmployee ?? false,
);

export const getUserSeniorSupportPermission = createSelector(
    [getUser],
    (user) =>
        (user?.snackpassPermissions.isSnackpassEmployee &&
            user?.snackpassPermissions.isSeniorSupport) ??
        false,
);

export const getUserFeeSettingsPermission = createSelector(
    [getUser],
    (user) => {
        if (!user?.snackpassPermissions?.isSnackpassEmployee) {
            return false;
        }
        if (config.isProduction) {
            return user?.snackpassPermissions?.hasFeeSettings ?? false;
        }
        return true;
    },
);

export const getUserIsTestEnabled = createSelector(
    [getUser],
    (user) => user?.test?.testEnabled ?? false,
);

export const getUserIsAdmin = createSelector(
    [getUser],
    (user) => user?.snackpassPermissions?.isAdmin ?? false,
);

export const useActiveUser = () => useSelector(getUser);

export const getUserSnackpassPermissionsStoreIds = createSelector(
    [getUser],
    (user) => user?.snackpassPermissions?.storeIds ?? [],
);
